import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENVIRONMENT, Environment } from '@netfoundry-ui/shared/model';
import { HTTP_CLIENT } from './token.service';
import { LoggerService } from './logger.service';


@Injectable({ providedIn: 'root' })
export class OrganizationService {
  static readonly defaultHttpAccept = {
    headers: { accept: 'application/hal+json' },
    pageParams: {
      page: 0,
      size: 2000,
    },
  };
  apiUrl;

  constructor(
    private readonly logger: LoggerService,
    @Inject(HTTP_CLIENT) private readonly http: HttpClient,
    @Inject(ENVIRONMENT) private readonly environment: Environment
  ) {
    this.apiUrl = this.environment.identityConfig.url;
  }

  public getOrganization(organizationId: string) {
    const fullpath = `${this.apiUrl}organizations/${organizationId}`;
    return this.http.get(fullpath);
  }

  // The roles available for the organization. The default-role picker excludes the ones already set as
  // defaults; callers using this as the organization's full assignable-role catalog pass false.
  public getAvailableDefaultRoles(organizationId: string, excludeExistingDefaultRoles = true): Promise<any[]> {
    const fullpath = `${this.apiUrl}default-roles/availableForOrganization`;
    const params = new HttpParams()
      .set('organizationId', organizationId)
      .set('excludeExistingDefaultRoles', `${excludeExistingDefaultRoles}`);
    return this.http.get<any[]>(fullpath, { params }).toPromise().then((roles) => roles || []);
  }

  // add a role as a default role for the organization (server derives the name)
  public createDefaultRole(organizationId: string, roleType: string, roleId: string) {
    const fullpath = `${this.apiUrl}default-roles`;
    return this.http.post(fullpath, { organizationId, roleType, roleId });
  }

}
